import axios from "axios"

//axios
const request = axios.create({
    baseURL: "https://123coco.com/api"
    // baseURL: "http://127.0.0.1:8000/api"
})

export default request
